var map = {
	"./amex.png": 6786,
	"./diners.png": 4004,
	"./elo.png": 3641,
	"./hipercard.png": 759,
	"./maestro.png": 3544,
	"./mastercard.png": 6947,
	"./visa.png": 3456
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3804;